import script from "./ContatoreTable3.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoreTable3.vue?vue&type=script&setup=true&lang=js"

import "./ContatoreTable3.vue?vue&type=style&index=0&id=48dbb57c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48dbb57c"]])

export default __exports__